import React, { useState } from 'react'
import EDTable from './EDGames'
import MGTable from './MGGames'
import EDGame from './EDGame'
import MGGame from './MGGame'
import { Container, Menu, MenuItem } from 'semantic-ui-react'

const Suppliers = () => {
    const [activeItem, setActiveItem] = useState('ed')
    const [edGame, setEdGame] = useState('')
    const [mgGameName, setMgGameName] = useState('')
    const [mgGameID, setMgGameID] = useState('')

    const handleMenuItemClicked = e => {
        switch (e.target.innerText) {
            case 'Elite Dias':
                setActiveItem('ed')
                break
            case 'Moogold':
                setActiveItem('mg')
                break
            case 'Admins':
                setActiveItem('admins')
                break
            default:
                break
        }
    }
    const handleEDGameClicked = game => {
        setEdGame(game)
        setActiveItem('ed-game')
    }
    const handleMGGameClicked = (id, name) => {
        setMgGameID(id)
        setMgGameName(name)
        setActiveItem('mg-game')
    }

    const renderContent = () => {
        switch (activeItem) {
            case 'ed':
                return <EDTable gameClicked={handleEDGameClicked}/>
            case 'ed-game':
                return <EDGame game={edGame} goBack={() => setActiveItem('ed')}/>
            case 'mg':
                return <MGTable gameClicked={handleMGGameClicked}/>
            case 'mg-game':
                return <MGGame game={mgGameName} gameID={mgGameID} goBack={() => setActiveItem('mg')}/>
            default:
                return
        }
    }

    return (
        <Container inverted style={{ background: '#1b1c1d' }}>
            <Menu size={window.innerWidth < 768 ? 'mini' : null} inverted pointing secondary>
                <MenuItem name='Elite Dias' active={activeItem === 'ed' || activeItem === 'ed-game'} onClick={handleMenuItemClicked}/>
                <MenuItem name='Moogold' active={activeItem === 'mg' || activeItem === 'mg-game'} onClick={handleMenuItemClicked}/>
            </Menu>
            {renderContent()}
        </Container>
    )
}

export default Suppliers